import PieChartElement from '@/views/elements/chart/PieChartElement';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import classNames from 'classnames/bind';
import styles from './AllocationCategoryChart.module.scss';
import './InvestmentZoningChart.scss';
import { useEffect, useState } from 'react';
import { getAllocPortfoliosFollower } from '@/controllers/gridManager/followerTransManager/followerTransManager';
import { Box, Stack } from '@mui/system';
import { useGetIndustry, useGetLanguage } from '@/controllers/gridManager/appManager/appManager';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';

const cx = classNames.bind(styles);

type Props = {
    fullWidth?: boolean
    accountId: string
    masterAccount?: string
}

const NUMBER_SHOW_CHART = 5

export default function AllocationCategoryChart({
    accountId, masterAccount
}: Props) {
    const { t } = useTranslation()
    const { language } = useGetLanguage()

    const [dataSeries, setDataSeries] = useState<any>([])

    const [type, setType] = useState(0)

    const { industry } = useGetIndustry()

    const prepareDataForChartAllocPortfolios = (raw: any) => {
        const cloneRaw = cloneDeep(raw)
        cloneRaw.sort((a: any, b: any) => b.value - a.value)

        // console.log('ha_check_cloneRaw_sort', cloneRaw)
        const dataForChart: { name: string, value: number }[] = []
        const Other = { name: t("copytrade.common.other"), value: 0 }
        const Money = { name: t("copytrade.common.money"), value: 0 }

        let count = 0
        for (let index = 0; index < cloneRaw.length; index++) {
            const element = cloneRaw[index];
            if (element?.name === "Tiền") {
                Money.value = Money.value + parseFloat(element?.value)
            } else if (element?.value && count < NUMBER_SHOW_CHART) {
                count += 1
                dataForChart.push(element)
            } else if (element?.value && element?.value !== 0) {
                // console.log('ha_check_elementOther', element)
                Other.value = Other.value + parseFloat(element?.value)
            }

            // if (element?.value >= MIN_VALUE_CHART) {
            //     dataForChart.push(element)
            // } else if (element?.value && element?.value !== 0) {
            //     Other.value = Other.value + parseFloat(element?.value)
            // }
        }

        if (Money && Money.value !== 0) {
            dataForChart.push(Money)
        }

        if (Other && Other.value !== 0) {
            dataForChart.push(Other)
        }
        return dataForChart
    }

    useEffect(() => {
        async function callApiDataChart() {
            const { isSuccess, data } = await getAllocPortfoliosFollower(accountId, masterAccount)
            const rs = data
            if (isSuccess) {
                // console.log('ha_check_getAllocPortfoliosFollower', { data, industry });
                setDataSeries(rs)
            }
        }
        setDataSeries([])
        callApiDataChart()
    }, [masterAccount, language])


    const data4PieChart = prepareDataForChartAllocPortfolios(dataSeries)

    // console.log('ha_check_data4PieChart', data4PieChart)
    const listSymbol = dataSeries.map((item: any) => item.name)

    const result = industry.map((subIndustry: any) => {
        const matchedCodes = listSymbol.filter((code: any) => subIndustry?.codeList?.includes(code));
        return {
            industryNameEn: subIndustry.industryNameEn,
            industryName: subIndustry.industryName,
            matchedCodes: matchedCodes
        };
    });

    const filteredResult = result.filter((item: any) => item.matchedCodes.length > 0);
    const filterWithoutMoney = listSymbol.filter((code: any) => code !== 'Tiền')

    const unmatchedCodes = filterWithoutMoney.filter((code: any) => (!result.some((subIndustry: any) => subIndustry.matchedCodes.includes(code))));

    // console.log('ha_check_result', { result, filteredResult, filterWithoutMoney, unmatchedCodes })

    const findMoney = dataSeries.find((item: any) => item.name === 'Tiền')

    if (findMoney && findMoney.value !== 0) {
        filteredResult.push({
            industryName: "Tiền",  // Ngành khác
            industryNameEn: "Money",
            matchedCodes: ["Tiền"]
        });
    }

    if (unmatchedCodes.length > 0) {
        filteredResult.push({
            industryName: "Khác",  // Ngành khác
            industryNameEn: "Other",
            matchedCodes: unmatchedCodes
        });
    }

    const data4Industry = filteredResult.map((item: any) => {
        let sum = 0
        for (let index = 0; index < dataSeries.length; index++) {
            const element = dataSeries[index];
            if (item?.matchedCodes.includes(element.name)) {
                sum += element.value
            }
        }
        return { name: language === "vi" ? item.industryName : item.industryNameEn, value: sum }
    })

    const buildData4Industry = prepareDataForChartAllocPortfolios(data4Industry)

    // console.log('ha_check_getAllocPortfoliosFollower111', { buildData4Industry });

    return (
        <Stack spacing='20px' p='20px' direction='column' className={cx("allocation")}>
            <Stack direction='row' alignItems='center' justifyContent='space-between'>
                <TypographyElement FontWeightElement={700} FontSizeElement='16px' lineHeight='24px'>{t('copytrade.chart.allocation.title')}</TypographyElement>
                <Stack className={cx("allocation__switch")} direction='row'>
                    <Box className={cx("allocation__switch-thumb")} sx={{ left: `${type * 60}px` }}></Box>
                    <TypographyElement onClick={() => setType(0)} className={cx("allocation__switch-content")}>{t('copytrade.chart.allocation.instrument')}</TypographyElement>
                    <TypographyElement onClick={() => setType(1)} className={cx("allocation__switch-content")}>{t('copytrade.chart.allocation.industry')}</TypographyElement>
                </Stack>
            </Stack>
            <div className={cx("allocation__body")}>
                <PieChartElement
                    dataSeries={type === 0 ? data4PieChart : buildData4Industry}
                    isLongLabel={type === 1}
                />
            </div>
        </Stack>
    )
}